import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../constants/route'
import {
  EntityProfileHeader,
  EntityProfileHeaderTitleWithStatus,
} from '../../../Entity'
import { ICON_COLOR, ICON_HEIGHT_16, IconWithTooltip } from '../../../Icon'
import {
  APPLICANT_NEW_BADGE_TEXT_COLOR,
  getIsRentalPortalApplicantIdentityMasked,
  getIsRentalPortalApplicantNew,
} from '../../../RentalPortalApplicant'
import { Status, STATUS_SIZE_16 } from '../../../Status'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'
import { getApplicantProfileTitle } from '../RentalPortalApplicantProfile.utils'
import { RentalPortalApplicantProfileHeaderInfoItems } from '../RentalPortalApplicantProfileHeaderInfoItems'
import { RentalPortalApplicantProfileHeaderStageSelect } from '../RentalPortalApplicantProfileHeaderStageSelect'

import { QA_NAME_APPLICANT_PROFILE_HEADER_NEW_BADGE } from './RentalPortalApplicantProfileHeader.constants'
import { getApplicantProfileHeaderAvatarProps } from './RentalPortalApplicantProfileHeader.utils'

import * as styles from './RentalPortalApplicantProfileHeader.module.css'

import LockIcon from '../../../../icons/lock.svg'

function RentalPortalApplicantProfileHeader() {
  const { t } = useTranslation()

  const { applicantData, isInitiated } = useApplicantProfileContext()

  return (
    <EntityProfileHeader
      Content={null}
      Footer={null}
      Header={EntityProfileHeaderTitleWithStatus}
      InfoItems={RentalPortalApplicantProfileHeaderInfoItems}
      headerProps={{
        Status: RentalPortalApplicantProfileHeaderStageSelect,
        entityAvatarProps: getApplicantProfileHeaderAvatarProps({
          applicantData,
          t,
        }),
        sectionBackUrl: `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}/${ROUTE_PATH_LIST_RENTAL_PORTAL.applicants}`,
        statusProps: { className: styles.stageSelect },
        text: getApplicantProfileTitle({ applicantData, t }),
        textProps: {
          additionalIcons: (
            <>
              {getIsRentalPortalApplicantNew(applicantData) ? (
                <Status
                  className={styles.newBadge}
                  height={STATUS_SIZE_16}
                  qaName={QA_NAME_APPLICANT_PROFILE_HEADER_NEW_BADGE}
                  text={t('RentalPortal.ApplicantBadgeNewKey')}
                  textColor={APPLICANT_NEW_BADGE_TEXT_COLOR}
                />
              ) : null}
              {getIsRentalPortalApplicantIdentityMasked(applicantData) ? (
                <IconWithTooltip
                  Icon={LockIcon}
                  color={ICON_COLOR.SecondaryTextColor}
                  size={ICON_HEIGHT_16}
                  tooltip={t('RentalPortal.ApplicantIdentityMaskedTooltipKey')}
                  tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
                />
              ) : null}
            </>
          ),
          editable: false,
        },
      }}
      isLoading={!isInitiated}
    />
  )
}

export default RentalPortalApplicantProfileHeader
